// Global toast notification utility

import './toast.css'

let activeToast: HTMLElement | null = null

/**
 * Show a brief toast message. Auto-removes after 2.5 seconds.
 */
export function showToast(message: string): void {
  // Remove existing toast
  if (activeToast) {
    activeToast.remove()
    activeToast = null
  }

  const el = document.createElement('div')
  el.className = 'editor-toast'
  el.textContent = message
  document.body.appendChild(el)
  activeToast = el

  // Force reflow then show
  void el.offsetWidth
  el.classList.add('visible')

  setTimeout(() => {
    el.classList.remove('visible')
    setTimeout(() => {
      if (activeToast === el) {
        el.remove()
        activeToast = null
      }
    }, 200)
  }, 2500)
}
